import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  year: any;
  email = 'campaigns.support@syngenta.com';
  isEnrollmentClosed:boolean=false;
  code: any;
  error: any;

  constructor(private route: Router,private activateRoute: ActivatedRoute,public authService:AuthService){
    

  }
  ngOnInit() {
    this.year = new Date().getFullYear();
    this.route.events.subscribe((val) => {
      
      if (this.route.url === "/enrollment-close") {
        this.isEnrollmentClosed = true;
      } else {
        this.isEnrollmentClosed = false;
      }
      
    });
  }
}
